import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import authStore from '@/store/auth.store';
import applicationStore from '@/store/application.store';
import magazineStore from '@/store/magazine.store';
import trackingStore from '@/store/tracking.store';
import { RootState } from '@/store/storeStateInterfaces';
import VuexPersistence from 'vuex-persist';
import bookmarkStore from '@/store/bookmark.store';
import EncryptionStorage from '@/misc/EncryptionStorage';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence<RootState>({
    key: process.env.VUE_APP_STORAGE_KEY!,
    storage: EncryptionStorage.getInstance() as any,
    reducer: (state) => ({
        magazine: {
            pagination: state.magazine.pagination,
            filter: {
                category: state.magazine.filter.category,
                languages: state.magazine.filter.languages
            }
        },
        auth: {
            token: state.auth.token,
            currentUser: state.auth.currentUser
        },
        bookmark: {
            bookmarks: state.bookmark.bookmarks
        },
        application: {
            customTheme: state.application.customTheme,
            accessibilityControls: state.application.accessibilityControls,
            usingCode: state.application.usingCode,
            noAnimations: state.application.noAnimations,
            termsAndConditionsConfirmed: state.application.termsAndConditionsConfirmed
        },
        tracking: {
            currentTracking: state.tracking.currentTracking
        }
    }),
    filter: (mutation) => {
        return [
            // auth
            'auth/saveUser', 'auth/setToken',
            // magazine
            'magazine/applyFilter', 'magazine/setPagination',
            // bookmark
            'bookmark/saveBookmark', 'bookmark/removeBookmark',
            // application
            'application/setCustomTheme', 'application/setAccessibilityControls', 'application/setTermsAndConditionsConfirmed',
            'application/setUsingCode', 'application/setNoAnimations',
            // tracking
            'tracking/startTracking', 'tracking/addTrackingPage', 'tracking/clearTracking', 'tracking/setLastPageEnd'
        ].includes(mutation.type);
    }
});

const store: StoreOptions<RootState> = {
    modules: {
        auth: {
            namespaced: true,
            ...authStore
        },
        application: {
            namespaced: true,
            ...applicationStore
        },
        magazine: {
            namespaced: true,
            ...magazineStore
        },
        tracking: {
            namespaced: true,
            ...trackingStore
        },
        bookmark: {
            namespaced: true,
            ...bookmarkStore
        }
    },
    plugins: [vuexLocal.plugin]
};

export default new Vuex.Store<RootState>(store);
